import React from 'react';
// ایمپورت کامپوننت‌ها از کتابخانه جدید
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const JalaliDatePicker = ({ value, onChange, disabled = false, placeholder }) => {

  const handleDateChange = (dateObject) => {
    if (disabled || !onChange) return;

    if (dateObject) {
      // تاریخ انتخاب شده که در تقویم شمسی است، به صورت رشته شمسی
      // به کامپوننت والد ارسال می‌شود تا سمت سرور تبدیل شود.
      const jalaliDateString = dateObject.format("YYYY-MM-DD");
      onChange(jalaliDateString);
    } else {
      onChange(''); // برای پاک کردن تاریخ
    }
  };

  return (
    <span className="date-picker-wrapper">
      <DatePicker
        // پراپرتی value یک رشته تاریخ شمسی از state والد دریافت می‌کند (مثلاً "1404-05-11").
        // کامپوننت این مقدار را درک می‌کند چون تقویم آن روی فارسی تنظیم شده است.
        value={value} 
        onChange={handleDateChange}
        disabled={disabled}
        // تنظیم تقویم و زبان به فارسی (شمسی)
        calendar={persian}
        locale={persian_fa}
        // استفاده از کلاس موجود برای هماهنگی ظاهری
        inputClass="due-date-picker"
        placeholder={placeholder || "تاریخ سررسید..."}
        // این فرمت برای نمایش تاریخ در اینپوت است و به صورت شمسی نمایش داده می‌شود.
        format="YYYY/MM/DD"
      />
    </span>
  );
};

export default JalaliDatePicker;